// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Color CSS Variables — dark neutral base.
   Mood tokens (--mood-*) live in src/styles/moods.css and are applied via
   [data-mood] on <html>. This file must be imported before moods.css. */
:root {
  color-scheme: dark;

  /* Base neutrals */
  --bg-base: #0B0C0E;
  --surface-1: #141619;
  --surface-2: #1C1F23;
  --surface-3: #24282D;

  /* Borders */
  --border-subtle: rgba(255, 255, 255, 0.08);
  --border-strong: rgba(255, 255, 255, 0.16);

  /* Text */
  --text-primary: #F2F3F4;
  --text-secondary: rgba(242, 243, 244, 0.72);
  --text-tertiary: rgba(242, 243, 244, 0.52);
  --text-on-accent: #0B0C0E;

  /* Elevation tuned for near-black surfaces */
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.5);
  --shadow-md: 0 12px 28px rgba(0, 0, 0, 0.55);
  --shadow-lg: 0 24px 56px rgba(0, 0, 0, 0.6);

  /* Scrims */
  --scrim: rgba(0, 0, 0, 0.72);

  /* Accent resolves from the active mood */
  --accent: var(--mood-accent, #6FD8C8);
  --accent-soft: color-mix(in srgb, var(--accent) 16%, transparent);
  --accent-softer: color-mix(in srgb, var(--accent) 8%, transparent);
  --accent-ring: color-mix(in srgb, var(--accent) 32%, transparent);
  --accent-dim: color-mix(in srgb, var(--accent) 72%, var(--bg-base));

  /* Primary Colors (legacy names, remapped onto the dark system) */
  --color-primary-green: var(--accent);
  --color-light-green: var(--accent-soft);
  --color-dark-green: var(--accent);

  /* Neutral Colors.
     --color-white historically meant "card background"; it now resolves to the
     raised dark surface. Text that sits on an accent fill uses --text-on-accent. */
  --color-white: var(--surface-1);
  --color-black: var(--text-primary);
  --color-light-gray: var(--surface-2);
  --color-dark-gray: var(--text-secondary);
  --color-gray: var(--border-strong);

  /* Warning Colors */
  --color-warning-yellow: #FFC943;
  --color-warning-red: #FF6B85;

  /* Pastelle Colors -> tinted dark surfaces */
  --color-pastelle-yellow: rgba(255, 201, 67, 0.14);
  --color-pastelle-red: rgba(255, 107, 133, 0.14);
  --color-pastelle-gray: var(--surface-2);
  --color-pastelle-blue: var(--accent-softer);

  /* Additional Colors */
  --color-gray-100: var(--surface-2);
  --color-gray-500: var(--text-tertiary);
  --color-light-blue: var(--accent-softer);

  /* Aliases used by the terms/privacy sheets */
  --color-text-primary: var(--text-primary);
  --color-text-secondary: var(--text-secondary);

  /* Layout / surface system (full-bleed shell) */
  --color-canvas: var(--bg-base);
  --color-surface: var(--surface-1);
  --color-surface-muted: var(--surface-2);
  --color-border-subtle: var(--border-subtle);
  --color-border: var(--border-strong);

  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --radius-xl: 20px;

  --space-1: 4px;
  --space-2: 8px;
  --space-3: 12px;
  --space-4: 16px;
  --space-5: 20px;
  --space-6: 24px;
  --space-7: 32px;
  --space-8: 40px;

  --layout-outer: 16px;
  --layout-gap: 12px;
  --layout-content-max: 1120px;
  /* Page bodies share the topbar's measure so their edges line up */
  --layout-page-max: var(--layout-content-max);
  --layout-page-pad: 28px;
  --layout-page-pad-mobile: 16px;
}

/* Color utility classes */
.color {
  /* Base color class */
}

/* Individual color classes for direct use */
.color-primary-green {
  color: var(--color-primary-green);
}

.color-light-green {
  color: var(--accent);
}

.color-dark-green {
  color: var(--color-dark-green);
}

.color-white {
  color: var(--text-primary);
}

.color-black {
  color: var(--text-primary);
}

.color-light-gray {
  color: var(--text-secondary);
}

.color-dark-gray {
  color: var(--color-dark-gray);
}

.color-gray {
  color: var(--text-tertiary);
}

.color-warning-yellow {
  color: var(--color-warning-yellow);
}

.color-warning-red {
  color: var(--color-warning-red);
}

.color-pastelle-yellow {
  color: var(--color-warning-yellow);
}

.color-pastelle-red {
  color: var(--color-warning-red);
}

.color-pastelle-gray {
  color: var(--text-secondary);
}

.color-pastelle-blue {
  color: var(--accent);
}

.color-gray-100 {
  color: var(--text-secondary);
}

.color-gray-500 {
  color: var(--color-gray-500);
}

.color-light-blue {
  color: var(--accent);
}

/* Background color utility classes */
.bg-primary-green {
  background-color: var(--color-primary-green);
}

.bg-light-green {
  background-color: var(--color-light-green);
}

.bg-dark-green {
  background-color: var(--accent-dim);
}

.bg-white {
  background-color: var(--surface-1);
}

.bg-black {
  background-color: var(--bg-base);
}

.bg-light-gray {
  background-color: var(--color-light-gray);
}

.bg-dark-gray {
  background-color: var(--surface-3);
}

.bg-gray {
  background-color: var(--surface-3);
}

.bg-warning-yellow {
  background-color: var(--color-warning-yellow);
}

.bg-warning-red {
  background-color: var(--color-warning-red);
}

.bg-pastelle-yellow {
  background-color: var(--color-pastelle-yellow);
}

.bg-pastelle-red {
  background-color: var(--color-pastelle-red);
}

.bg-pastelle-gray {
  background-color: var(--color-pastelle-gray);
}

.bg-pastelle-blue {
  background-color: var(--color-pastelle-blue);
}

.bg-gray-100 {
  background-color: var(--color-gray-100);
}

.bg-gray-500 {
  background-color: var(--surface-3);
}

.bg-light-blue {
  background-color: var(--color-light-blue);
}
`, "",{"version":3,"sources":["webpack://./src/components/Colors/Colors.css"],"names":[],"mappings":"AAAA;;wEAEwE;AACxE;EACE,kBAAkB;;EAElB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,YAAY;EACZ,0CAA0C;EAC1C,0CAA0C;;EAE1C,SAAS;EACT,uBAAuB;EACvB,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;;EAEzB,4CAA4C;EAC5C,yCAAyC;EACzC,4CAA4C;EAC5C,2CAA2C;;EAE3C,WAAW;EACX,4BAA4B;;EAE5B,yCAAyC;EACzC,qCAAqC;EACrC,iEAAiE;EACjE,kEAAkE;EAClE,iEAAiE;EACjE,mEAAmE;;EAEnE,iEAAiE;EACjE,oCAAoC;EACpC,uCAAuC;EACvC,iCAAiC;;EAEjC;;mFAEiF;EACjF,+BAA+B;EAC/B,kCAAkC;EAClC,oCAAoC;EACpC,wCAAwC;EACxC,kCAAkC;;EAElC,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;;EAE5B,4CAA4C;EAC5C,iDAAiD;EACjD,+CAA+C;EAC/C,uCAAuC;EACvC,2CAA2C;;EAE3C,sBAAsB;EACtB,kCAAkC;EAClC,sCAAsC;EACtC,wCAAwC;;EAExC,6CAA6C;EAC7C,yCAAyC;EACzC,6CAA6C;;EAE7C,+CAA+C;EAC/C,8BAA8B;EAC9B,iCAAiC;EACjC,uCAAuC;EACvC,2CAA2C;EAC3C,oCAAoC;;EAEpC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;;EAEf,oBAAoB;EACpB,kBAAkB;EAClB,4BAA4B;EAC5B,kEAAkE;EAClE,4CAA4C;EAC5C,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;AACvB;;AAEA,4CAA4C;AAC5C;EACE,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C","sourcesContent":["/* Color CSS Variables — dark neutral base.\n   Mood tokens (--mood-*) live in src/styles/moods.css and are applied via\n   [data-mood] on <html>. This file must be imported before moods.css. */\n:root {\n  color-scheme: dark;\n\n  /* Base neutrals */\n  --bg-base: #0B0C0E;\n  --surface-1: #141619;\n  --surface-2: #1C1F23;\n  --surface-3: #24282D;\n\n  /* Borders */\n  --border-subtle: rgba(255, 255, 255, 0.08);\n  --border-strong: rgba(255, 255, 255, 0.16);\n\n  /* Text */\n  --text-primary: #F2F3F4;\n  --text-secondary: rgba(242, 243, 244, 0.72);\n  --text-tertiary: rgba(242, 243, 244, 0.52);\n  --text-on-accent: #0B0C0E;\n\n  /* Elevation tuned for near-black surfaces */\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.5);\n  --shadow-md: 0 12px 28px rgba(0, 0, 0, 0.55);\n  --shadow-lg: 0 24px 56px rgba(0, 0, 0, 0.6);\n\n  /* Scrims */\n  --scrim: rgba(0, 0, 0, 0.72);\n\n  /* Accent resolves from the active mood */\n  --accent: var(--mood-accent, #6FD8C8);\n  --accent-soft: color-mix(in srgb, var(--accent) 16%, transparent);\n  --accent-softer: color-mix(in srgb, var(--accent) 8%, transparent);\n  --accent-ring: color-mix(in srgb, var(--accent) 32%, transparent);\n  --accent-dim: color-mix(in srgb, var(--accent) 72%, var(--bg-base));\n\n  /* Primary Colors (legacy names, remapped onto the dark system) */\n  --color-primary-green: var(--accent);\n  --color-light-green: var(--accent-soft);\n  --color-dark-green: var(--accent);\n\n  /* Neutral Colors.\n     --color-white historically meant \"card background\"; it now resolves to the\n     raised dark surface. Text that sits on an accent fill uses --text-on-accent. */\n  --color-white: var(--surface-1);\n  --color-black: var(--text-primary);\n  --color-light-gray: var(--surface-2);\n  --color-dark-gray: var(--text-secondary);\n  --color-gray: var(--border-strong);\n\n  /* Warning Colors */\n  --color-warning-yellow: #FFC943;\n  --color-warning-red: #FF6B85;\n\n  /* Pastelle Colors -> tinted dark surfaces */\n  --color-pastelle-yellow: rgba(255, 201, 67, 0.14);\n  --color-pastelle-red: rgba(255, 107, 133, 0.14);\n  --color-pastelle-gray: var(--surface-2);\n  --color-pastelle-blue: var(--accent-softer);\n\n  /* Additional Colors */\n  --color-gray-100: var(--surface-2);\n  --color-gray-500: var(--text-tertiary);\n  --color-light-blue: var(--accent-softer);\n\n  /* Aliases used by the terms/privacy sheets */\n  --color-text-primary: var(--text-primary);\n  --color-text-secondary: var(--text-secondary);\n\n  /* Layout / surface system (full-bleed shell) */\n  --color-canvas: var(--bg-base);\n  --color-surface: var(--surface-1);\n  --color-surface-muted: var(--surface-2);\n  --color-border-subtle: var(--border-subtle);\n  --color-border: var(--border-strong);\n\n  --radius-sm: 8px;\n  --radius-md: 12px;\n  --radius-lg: 16px;\n  --radius-xl: 20px;\n\n  --space-1: 4px;\n  --space-2: 8px;\n  --space-3: 12px;\n  --space-4: 16px;\n  --space-5: 20px;\n  --space-6: 24px;\n  --space-7: 32px;\n  --space-8: 40px;\n\n  --layout-outer: 16px;\n  --layout-gap: 12px;\n  --layout-content-max: 1120px;\n  /* Page bodies share the topbar's measure so their edges line up */\n  --layout-page-max: var(--layout-content-max);\n  --layout-page-pad: 28px;\n  --layout-page-pad-mobile: 16px;\n}\n\n/* Color utility classes */\n.color {\n  /* Base color class */\n}\n\n/* Individual color classes for direct use */\n.color-primary-green {\n  color: var(--color-primary-green);\n}\n\n.color-light-green {\n  color: var(--accent);\n}\n\n.color-dark-green {\n  color: var(--color-dark-green);\n}\n\n.color-white {\n  color: var(--text-primary);\n}\n\n.color-black {\n  color: var(--text-primary);\n}\n\n.color-light-gray {\n  color: var(--text-secondary);\n}\n\n.color-dark-gray {\n  color: var(--color-dark-gray);\n}\n\n.color-gray {\n  color: var(--text-tertiary);\n}\n\n.color-warning-yellow {\n  color: var(--color-warning-yellow);\n}\n\n.color-warning-red {\n  color: var(--color-warning-red);\n}\n\n.color-pastelle-yellow {\n  color: var(--color-warning-yellow);\n}\n\n.color-pastelle-red {\n  color: var(--color-warning-red);\n}\n\n.color-pastelle-gray {\n  color: var(--text-secondary);\n}\n\n.color-pastelle-blue {\n  color: var(--accent);\n}\n\n.color-gray-100 {\n  color: var(--text-secondary);\n}\n\n.color-gray-500 {\n  color: var(--color-gray-500);\n}\n\n.color-light-blue {\n  color: var(--accent);\n}\n\n/* Background color utility classes */\n.bg-primary-green {\n  background-color: var(--color-primary-green);\n}\n\n.bg-light-green {\n  background-color: var(--color-light-green);\n}\n\n.bg-dark-green {\n  background-color: var(--accent-dim);\n}\n\n.bg-white {\n  background-color: var(--surface-1);\n}\n\n.bg-black {\n  background-color: var(--bg-base);\n}\n\n.bg-light-gray {\n  background-color: var(--color-light-gray);\n}\n\n.bg-dark-gray {\n  background-color: var(--surface-3);\n}\n\n.bg-gray {\n  background-color: var(--surface-3);\n}\n\n.bg-warning-yellow {\n  background-color: var(--color-warning-yellow);\n}\n\n.bg-warning-red {\n  background-color: var(--color-warning-red);\n}\n\n.bg-pastelle-yellow {\n  background-color: var(--color-pastelle-yellow);\n}\n\n.bg-pastelle-red {\n  background-color: var(--color-pastelle-red);\n}\n\n.bg-pastelle-gray {\n  background-color: var(--color-pastelle-gray);\n}\n\n.bg-pastelle-blue {\n  background-color: var(--color-pastelle-blue);\n}\n\n.bg-gray-100 {\n  background-color: var(--color-gray-100);\n}\n\n.bg-gray-500 {\n  background-color: var(--surface-3);\n}\n\n.bg-light-blue {\n  background-color: var(--color-light-blue);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
